<template>
  <div>
    <!-- 产品列表 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <el-row class="conentRow">
        <div>
          <el-col class="conentCol" >
            <el-input placeholder="请输入产品名称/产品ID" clearable v-model="name" />
          </el-col>
          <el-col class="conentColSele" >
            <el-select v-model="data.ProductType" placeholder="全部分类" clearable>
              <el-option
                v-for="item in typeArr"
                :key="item.typeid"
                :label="item.typename"
                :value="item.typeid"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="conentColSele" >
            <el-select v-model="data.UseFlag" placeholder="全部状态" clearable>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col class="conentBtn" style="width:auto;" >
            <el-button type="primary" @click="btns">查询</el-button>
          </el-col>
        </div>
        <div>
          <!-- <div class="scenicBtnDel">
            <el-button type="primary" plain>
              <img
                style="width:12px;height:12px;vertical-align: middle;"
                src="@/images/scenic/tj.png"
                alt
              />
              删除
            </el-button>
          </div> -->
          <!-- <div class="scenicBtnPx">
            <el-button type="primary" plain @click="pxFn">
              <i class="iconfont icon-jiahao"></i> 
              <img
                style="width:12px;height:12px;vertical-align: middle;"
                src="@/images/scenic/px.png"
                alt
              />
              排序
            </el-button>
          </div> -->
            <div class="detele_btns" @click="batchClick">
              批量删除
            </div>
            <el-button type="primary" plain @click="addProFn()">
              添加产品
            </el-button>
        </div>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :header-cell-style="tableHeaderColor"
        :row-class-name="tableRowClassName"
        :cell-style="cellStyle"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column   label="排序" >
          <template slot-scope="scope">
            <el-input v-model="scope.row.sort" @blur="sortBlur(scope.row)" ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ProductID" label="ID" ></el-table-column>
        <el-table-column  label="分类">
          <template slot-scope="scope">
            <div class="product_divs" :class="{'has-flag-bg': !rows(scope.row),'lg_css': !rows(scope.row)}">
              <span>{{ scope.row.typename}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="产品名称" width="200">
            <!-- <template slot-scope="scope">
              <div class="product_divs">
                <img src="@/assets/guoqi.png" alt="" v-if="!rows(scope.row)">
                <div :class="rows(scope.row)==true?'':'lg_css'">
                  {{scope.row.ProductName}}
                </div>
              </div>
            </template> -->
            <template slot-scope="scope">
              <div >
                  {{scope.row.ProductName}}
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="ProductName" label="产品分类">
          <template slot-scope="scope">
            <span>{{ scope.row.type=='0'?'期票':'日历票' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Price" label="门市价"></el-table-column>
        <el-table-column prop="SellPrice" label="建议价"></el-table-column>
        <el-table-column prop="AgentPrice" label="代理价"></el-table-column>
        <el-table-column prop="NumBerflag" label="每日限制">
          <template  slot-scope="scope">
            <span>{{ scope.row.NumBerflag=='0'?'无限制':scope.row.NumBerflag }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="DayNum" label="已售(每日)"></el-table-column>
        <el-table-column prop="Number" label="总限制">
          <template  slot-scope="scope">
            <span>{{ scope.row.Number=='0'?'无限制':scope.row.Number }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="AllNum" label="已售(总)"></el-table-column>
        <el-table-column prop="address" label="状态">
          <template  slot-scope="scope">
            <div class="cursor" v-if="scope.row.UseFlag=='0'" @click="setup(1,scope.row.ProductID)">
              <img src="@/images/scenic/dl.png" alt />
              <span style="margin-left:9px">上线</span>
            </div>
            <div class="cursor"  v-if="scope.row.UseFlag=='1'"  @click="setup(0,scope.row.ProductID)">
              <img src="@/images/scenic/dh.png" alt />
              <span style="margin-left:9px">下线</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="退款">
          <template  slot-scope="scope">
            <div v-if="scope.row.ReturnFlag=='0'">
              <img src="@/images/scenic/dl.png" alt />
              <span style="margin-left:9px">可退</span>
            </div>
            <div  v-if="scope.row.ReturnFlag=='1'">
              <img src="@/images/scenic/dh.png" alt />
              <span style="margin-left:9px">不可退</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="200"    fixed="right">
          <template slot-scope="scope">
            <el-popconfirm
              confirm-button-text='确定'
              cancel-button-text='不用了'
              icon="el-icon-info"
              icon-color="red"
              title="确定删除吗？"
              @confirm="deteleFn(scope.row)"
            >
            <span slot="reference">删除</span>
            </el-popconfirm>
            <el-button type="text" @click="addProFns(scope.row)">详情</el-button>
            <el-button type="text" @click="copyClick(scope.row)">复制</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="totla">排序规则遵循降序规则，数据按照从大到小的顺序排列，数据越大内容越往前，新填加的内容系统默认排序为0</span>
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data.total" :page-size="data.page_size" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 排序弹框开始 -->
    <!-- <proLiPxdialog v-if="pxvisible" ref="pxDialog" :tableData="tableData" :data="data"></proLiPxdialog> -->
    <!-- 排序弹框结束 -->
    <!-- 添加产品弹框开始 -->
    <addProDialog v-if="addProvisible" ref="addProDialog" :typeArr="typeArr" @ProClose="ProClose" @addProClose="ProClose1"></addProDialog>
    <!-- 添加产品弹框结束 -->
    <addProDialogs v-if="addProvisibles" ref="addProDialogs" :typeArr="typeArr" @ProClose="ProCloses" @addProClose="ProClose1s"></addProDialogs>

  </div>
</template>

<script>
import {GetScenicList,ScenicProductType,DelScenicProduct,UpdateSort,SaveUseFlag,deleteAllProduct,copyPro} from '@/request/scenic.js'
import proLiPxdialog from "../pro/dialog/proLiPxdialog.vue";
import addProDialog from "../pro/dialog/addProDialog.vue";
import addProDialogs from "../pro/dialog/info.vue";
import { MessageBox } from 'element-ui';
export default {
  components: {
    proLiPxdialog,
    addProDialog,
    addProDialogs
  },
  data() {
    return {
      addProvisibles:false,
      pxvisible: false, // 排序弹框
      addProvisible:false, // 添加产品
      tableData: [
      ],
      options: [
        {
          value: "0",
          label: "上线"
        },
        {
          value: "1",
          label: "下线"
        }
      ],
      value: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        name:"",
        UseFlag:'',
        ProductType:'',
        business:'',
        page:1,
        page_size:12,
        total:0,
        ProductID:''
      },
      typeArr:[],
      multipleSelection:[],
      business:[
        {
          value:'1',
          label:"微商城"
        },
        {
          value:'2',
          label:"小程序"
        },
        {
          value:'3',
          label:"微餐饮"
        }
      ],
      name:''
    };
  },
  created(){
    this.getList()
    this.getType()
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      let flow = this.rows(row)
      if(!flow){
        return "warning-row";
      }
      if(row.UseFlag!=0){
        return "warning-row";
      }
    },
    rows(e){
      const startTime = new Date(e.ValidBeginDate); // 开始时间
      const endTime = new Date(e.ValidEndDate);
      const currentTime = new Date();
      if(e.UseFlag!=0){
        return false
      }
      if (currentTime >= startTime && currentTime <= endTime) {
        return true
      } else {
        return false
      }
    },
    copyClick(row){
      MessageBox(`此操作将复制产品, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            ProductId:row.ProductID
          }
          copyPro(data).then(res=>{
            if(res.data.status=='ok'){
              this.$message.success('复制成功')
              this.data.page = 1
              this.getList()
            }else{
              this.$message.error(res.data.msg)
            }
          })
      }).catch(() => {
                
      });
    },
    batchClick(){
      if(this.multipleSelection.length==0){
        this.$message.error('请选择产品')
        return false
      }
      MessageBox(`此操作将批量删除产品, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let id = ''
        this.multipleSelection.map(item=>{ 
          id += item.ProductID + ','
        })
        id = id.slice(0,-1)
        let data = {
          ProductIds:id,
          token:window.sessionStorage.getItem('Token'),
        }
        deleteAllProduct(data).then(res=>{
          if(res.data.status=='ok'){
            this.$message.success('批量删除成功')
            this.data.page = 1
            this.getList()
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
     
    },
    setup(i,id){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ProductId:id,
        UseFlag:i
      }
      let txt = ''
      console.log(i)
      if(i==0){
        txt = '上线'
      }else{
        txt = '下线'
      }
      MessageBox(`此操作将${txt}该产品, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        SaveUseFlag(data).then(res=>{
          if(res.data.status=='ok'){
            this.getList()
            this.$message.success('操作成功')
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
    },
    sortBlur(row){
      if(row.sort<0){
        this.$message.error('请输入大于0的整数')
        this.getList()
        return false
      }else{
        let num = /^[0-9]*$/.test(row.sort)
        if(num){
        }else{
          this.$message.error('请输入整数')
          this.getList()
          return false
        }
      }
      let data = {
        ProductId:row.ProductID,
        token:window.sessionStorage.getItem('Token'),
        sort:row.sort
      }
      UpdateSort(data).then(res=>{
        if(res.data.rcode=='200'){
          this.$message.success('排序成功')
          this.getList()
        }
      })
    },
    ProCloses(){
      this.getList()
      this.addProvisibles = false
    },
    ProClose1s(){
      this.getList()
      this.addProvisibles = false
    },
    ProClose(){
      this.getList()
      this.addProvisible = false
    },
    ProClose1(){
      this.getList()
      this.addProvisible = false
    },
    // 删除产品
    deteleFn(row){
      let data = {
        ProductID:row.ProductID,
        token:window.sessionStorage.getItem('Token'),
      }
      DelScenicProduct(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          this.$message.success('删除成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // 产品类型
    getType(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      ScenicProductType(data).then(res=>{
        if(res.data.status=='ok'){
          this.typeArr=res.data.result
        }
      })
    },
    // 查询
    btns(){
      this.data.page = 1
      if(this.name==''){
        this.data.ProductID = ''
        this.data.name = ''
      }
      if (!isNaN(this.name)) {
        this.data.ProductID = this.name
        this.data.name = ''
      } else {
        this.data.name = this.name
        this.data.ProductID = ''
      }
      this.getList()
    },
    // 获取产品列表数据
    getList(){
      GetScenicList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
        }
      })
    },
    // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    // 添加产品
    addProFn(row) {
      this.addProvisible = true;
      this.$nextTick(() => {
        this.$refs.addProDialog.addProFn(row);
      });
    },
    // 添加产品
    addProFns(row) {
      this.addProvisibles = true;
      this.$nextTick(() => {
        this.$refs.addProDialogs.addProFn(row);
      });
    },
    // 排序
    pxFn(row) {
      this.pxvisible = true;
      this.$nextTick(() => {
        this.$refs.pxDialog.pxFn(row);
      });
    },
    // 全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
::v-deep  .el-table .warning-row .cell {
  color: #B8B8B8;
}
/deep/.el-card__body {
  padding: 0 20px;
}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div:nth-child(1) {
      // width: 50%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .conentCol {
        width: 240px;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;
        /deep/.el-input {
          width: 100%;
        }
      }
      .conentColSele {
        margin-right: 10px;
        margin-bottom: 10px;
        width: 260px;
        position: relative;
        /deep/.el-select {
          width: 100%;
        }

      }
      .conentBtn {
        margin-bottom: 10px;
        // width: 120px;
        .el-button {
          width: 100px;
          // width: 84%;
          background: #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
    > div:nth-child(2) {
      // width: 50%;
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-left: auto;
      .scenicBtnDel {
        .el-button {
          width: 92px;
          background: #ffffff;
          border: 1px solid #ff4d4f;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #ff4d4f;
          box-sizing: border-box;
        }
      }
      .scenicBtnPx {
        margin: 0 20px;
        .el-button {
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          /* identical to box height */
          box-sizing: border-box;
          color: #246deb;
        }
      }
      .scenicBtn {
        .el-button {
          width: 120px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          box-sizing: border-box;
          color: #246deb;
        }
      }
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
::v-deep .el-popover__reference{
  color: #FF4D4F;
  margin-right: 1.9rem;
  cursor: pointer;
}
.cursor{
  cursor: pointer;
}
.conentRow /deep/ .el-button{
  color: #fff;
  background: #246deb;
}
/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
.totla{
  position: absolute;
  left: 2rem;
  width: 35rem;
  color: red !important;
}
.detele_btns{
  border-radius: 0.4rem;
  margin: 0 2rem;
  width: 9.2rem;
  height: 3.8rem;
  border: 1px solid #FF4D4F;
  color: #FF4D4F;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  cursor: pointer;
}
.lg_css{
  color: #B8B8B8;
  font-weight: 600;
  font-size: 1.4rem;
}
.product_divs{
  position: relative;
  img{
    position: absolute;
    width: 6.2rem;
    height: 3rem;
    left: 3rem;
    transform: translate(-50%,0);
    z-index: 9;
  }
}

.product_divs.has-flag-bg::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%) rotate(-30deg); /* 旋转15度 */
    width: 50px;
    height: 21px;
    background-image: url('../../../assets/guoqi.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 1;
}

// .product_divs.has-flag-bg {
//     background-image: url('../../../assets/guoqi.png');
//     background-size: 50px 21px;
//     background-repeat: no-repeat;
//     background-position: 0 center;
// }
</style>



